import { createApp } from 'vue';
import type { App, ComponentPublicInstance } from 'vue';
import CensorDialog from './main.vue';
import { sensitiveApi } from '../../../service/censorDialog'
import { ElMessage } from 'element-plus'
import { ElButton, ElDialog } from 'element-plus'
// 类型定义
interface sensitiveres {
  message?: string;
  msgCode?: string | number;
  responseData: {
    contentList: {
      check: boolean;
      [key: string]: any;
    }[];
  };
  [key: string]: any;
}
interface VMApp extends ComponentPublicInstance {
  [key: string]: any; // 允许任何字符串类型的键
}
// 全局变量
let vm: VMApp | null;
// 创建实例
const PromptBox = (props: { dialogState: boolean, fieldName: String }) => {
  return new Promise<void>((resolve) => {
    if (vm) return
    // 创建实例
    let instance: App | null = createApp(CensorDialog, {
      handleClick: () => {
        instance?.unmount();
        instance = null;
        vm = null
        resolve()
      }
    })
    // 注册依赖
    instance.use(ElButton);
    instance.use(ElDialog);
    // 创建文档碎片
    const dFrag = document.createDocumentFragment()
    // 将组件挂载在文档碎片上
    vm = instance.mount(dFrag as unknown as Element)
    // 组件显示
    document.body.appendChild(dFrag)
    // 设置值
    vm.fieldName = props.fieldName
    vm.setVisible(true)
  })
}


// 验证
CensorDialog.censor = async (params: Object) => {
  if (!Object.values(params).length) return
  if (vm && vm.dialogState) return
  const preHref = window.location.href
  const valueLists = Object.values(params)
  const data = { contentList: valueLists.map((val) => ({ "inputWord": val })) };

  try {
    const { responseData: { contentList } } = await sensitiveApi(data) as sensitiveres;
    const checkLists = contentList.filter((obj) => obj.check)
    if (checkLists.length) {
      if (preHref !== window.location.href) return
      const fieldName = Object.keys(params)[valueLists.findIndex((res) => res === checkLists[0].inputWord)]
      PromptBox({
        dialogState: true,
        fieldName
      }).then(() => {
        console.log("弹窗关闭");
      })
      return true
    }
  } catch (error) {
    ElMessage.error("文本校验接口异常，请稍后重试")
    return true
  }

}

export default CensorDialog;
